import { useReducer, useState } from 'react';

import { reducer, initialState } from './reducer';
import {
  setField as setFieldAC,
  setAll as setAllAC,
  SetFieldType,
  SetAllType,
} from './actions';

const useEditCohortHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [updated, setUpdated] = useState(false);

  const setField = (payload: SetFieldType) => {
    dispatch(setFieldAC(payload));
    setUpdated(true);
  }

  const setAll = (payload: SetAllType) => {
    dispatch(setAllAC(payload));
  }

  return {
    state,
    updated,
    setAll,
    setField,
  }
}

export default useEditCohortHook;
